<ng-template #modal let-modal>
    <div class="modal-header">
      <h5 class="q-c-main q-bold">Etes-vous sûr de vouloir supprimer définitivement ce cursus ?</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="container-modal p-0">
        <button class="btn q-btn q-danger m-2" type="button" (click)="deleteCursus();modal.dismiss()" title="Supprimer le cursus">Supprimer</button>
      </div>
    </div>
</ng-template>
